import React, { useEffect, useState } from 'react'
import {
  Modal, Card, Col, Row, Table,
} from 'antd'

import { format } from 'date-fns'

import { tr } from 'date-fns/locale'

import { fetch } from '../../../utils/fetch'

const { Column } = Table

const ModalPr = ({
  visiblePr,
  onCancel,
  orderId,
  orderItemId,
  dataPr,
}) => {
  const [dataTable, setDataTable] = useState([])

  useEffect(() => {
    if (dataPr && dataPr.length === 0) {
      console.log('soc')
    }
    console.log(dataPr)
    setDataTable(dataPr)
    // getOrderItemDetailBop()
  }, [visiblePr])

  return (
    <>
      <Modal
        title="Order Item Detail"
        visible={visiblePr}
        maskClosable={false}
        onCancel={() => { onCancel() }}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width="90vw"
        centered
      >
        <Row gutter={{ sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <Table
              // loading={bopLoading}
              dataSource={dataTable}
              size="small"
              scroll={{ x: 1000 }}
              bordered
            >
              <Column ellipsis align="center" title="Item" dataIndex="itmNumber" key="itmNumber" width={80} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Pr Item" dataIndex="prItem" key="prItem" width={80} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Pr No" dataIndex="prNo" key="prNo" width={100} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Scheduled Line" dataIndex="scheduledLine" key="scheduledLine" width={150} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Scheduled Type" dataIndex="scheduledType" key="scheduledType" width={150} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="request Qty" dataIndex="reqQty" key="reqQty" width={120} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Confirm Qty" dataIndex="confirmQty" key="confirmQty" width={120} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="Unit" dataIndex="unit" key="unit" width={80} render={(text) => text || '-'} />
              <Column ellipsis align="center" title="request Date" dataIndex="reqDate" key="reqDate" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy')} />
              <Column ellipsis align="center" title="request Time" dataIndex="reqTime" key="reqTime" width={150} render={(text) => text || '-'} />
            </Table>
          </Col>
        </Row>
      </Modal>
    </>
  )
}

export default ModalPr
